import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashCard from "./DashCard";
import ProgressBar from "../../Custom/ProgressBar";
import NoListItems from "../../Custom/NoListItems";

const FlashProgressCard = ({ deck }) => {
  const navigate = useNavigate();
  const isNewDeck = deck.status === "Start";
  const percentage = Math.min(Math.round(deck.progress), 100);

  const Badge = ({ label, color }) => {
    return (
      <div
        className="badge ellipsis"
        style={{
          backgroundColor: color,
          color: "var(--text)",
          maxWidth: "8rem",
          fontWeight: 300,
          borderRadius: 100,
          padding: "0.4rem 0.8rem",
        }}
      >
        {label}
      </div>
    );
  };

  return (
    <DashCard
      title={`${isNewDeck ? "Suggested Cards" : "Card Progress"}`}
      cornerContent={
        <Button
          color={`${isNewDeck ? "ghostGreen" : "ghostGold"}`}
          className="py-1 px-4"
          variant="contained"
          disableElevation
          onClick={() => navigate(deck.link)}
        >
          {deck.status}
        </Button>
      }
      children={
        <div className="progress-flash-content">
          {deck.subjects.length ? (
            <>
              <small>Study Subjects:</small>
              <div className="badge-container">
                {deck.subjects.slice(0, isNewDeck ? 6 : 4).map((title) => {
                  return (
                    <Badge
                      label={title}
                      key={`badge-${title} `}
                      color="var(--ghostBlack)"
                    />
                  );
                })}
              </div>
            </>
          ) : (
            <NoListItems
              text="Visit the flashcards page"
              customHeight="100%"
            />
          )}
          {!isNewDeck && <ProgressBar percentage={percentage} color="gold" />}
        </div>
      }
    />
  );
};

export default FlashProgressCard;
